// extracted by mini-css-extract-plugin
export default {"link":"LinkField_link__YQFET"};